import {button,escapeHtml} from './components.js';

const STATE_DEFAULTS=Object.freeze({
  loading:Object.freeze({title:'Ładowanie',text:'Przygotowujemy widok.',role:'status',busy:true}),
  empty:Object.freeze({title:'Jeszcze nic tu nie ma',text:'Ten obszar będzie gotowy, gdy dodasz pierwsze dane.',role:'status',busy:false}),
  offline:Object.freeze({title:'Brak połączenia',text:'Dymistrz zachowa lokalne dane. Funkcje wymagające internetu wrócą po połączeniu.',role:'status',busy:false}),
  error:Object.freeze({title:'Coś poszło nie tak',text:'Nie udało się wykonać operacji. Spróbuj ponownie.',role:'alert',busy:false}),
  unavailable:Object.freeze({title:'Funkcja jeszcze niedostępna',text:'Ten moduł nie jest jeszcze włączony w tej wersji Dymistrza.',role:'status',busy:false}),
  auth_required:Object.freeze({title:'Zaloguj się',text:'Ten obszar jest dostępny po zalogowaniu.',role:'status',busy:false})
});

export function stateView(kind,{title,text,retryId,retryLabel='Spróbuj ponownie'}={}){
  const safeKind=Object.hasOwn(STATE_DEFAULTS,kind)?kind:'error';
  const defaults=STATE_DEFAULTS[safeKind];
  const retry=retryId?`<div class="state-actions">${button({id:retryId,label:retryLabel,variant:'secondary'})}</div>`:'';
  return `<section class="state-view state-${safeKind}" role="${defaults.role}"${defaults.busy?' aria-busy="true"':''}><div class="state-symbol" aria-hidden="true"></div><div><strong>${escapeHtml(title||defaults.title)}</strong><p>${escapeHtml(text||defaults.text)}</p>${retry}</div></section>`;
}

export function loadingState(options){return stateView('loading',options);}
export function emptyState(options){return stateView('empty',options);}
export function offlineState(options){return stateView('offline',options);}
export function errorState(options){return stateView('error',options);}
export function unavailableState(options){return stateView('unavailable',options);}
export function authRequiredState(options){return stateView('auth_required',options);}
